import React from 'react';
import {
  type UserContextValue,
  UserContextProvider,
} from 'talent_matching/contexts/user_context';
import FilterForm from 'talent_matching/components/filter_form';
import { RankingInProgressProvider } from 'talent_matching/contexts/ranking_in_progress_context';
import { IndexingStatusProvider } from 'talent_matching/contexts/indexing_status_context';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useLocalStorage } from 'react-use';
import { TalentMatchingFilters } from 'talent_matching/types';

type Props = {
  initialFilters: Partial<TalentMatchingFilters>;
  jobTitle: string;
  previouslyCalibrated: boolean;
  pollRankingOnLoad: boolean;
  pollIndexingOnLoad: boolean;
  appReviewSessionId: number;
  isActive?: boolean;
} & UserContextValue;

const TalentMatching = ({
  initialFilters,
  jobTitle,
  previouslyCalibrated,
  pollRankingOnLoad,
  pollIndexingOnLoad,
  appReviewSessionId,
  isActive = true,
  ...userContextProps
}: Props) => {
  const [activeSidePanelTab, setActiveSidePanelTab] = useLocalStorage<
    string | null
  >('talent_matching_candidate_panel_tab', null);

  const [savedSearchOptions, setSavedSearchOptions] = React.useState(
    userContextProps.savedSearchOptions
  );

  return (
    <UserContextProvider
      value={{
        ...userContextProps,
        jobTitle,
        appReviewSessionId,
        activeSidePanelTab: activeSidePanelTab ?? null,
        setActiveSidePanelTab,
        savedSearchOptions,
        setSavedSearchOptions,
      }}
    >
      <IndexingStatusProvider pollOnLoad={pollIndexingOnLoad}>
        <RankingInProgressProvider
          pollOnLoad={pollRankingOnLoad}
          previouslyCalibrated={previouslyCalibrated}
        >
          <FilterForm initialFilters={initialFilters} isActive={isActive} />
          <ReactQueryDevtools initialIsOpen={false} />
        </RankingInProgressProvider>
      </IndexingStatusProvider>
    </UserContextProvider>
  );
};

export default TalentMatching;
